import QuantityActionTypes from 'yoda-site-components/lib/actionTypes/QuantityActionTypes';

export const setSelectedBundleQuantity = (quantity) => ({
    type: QuantityActionTypes.BUNDLE_QUANTITY_ON_CHANGE,
    payload: quantity,
});

export const resetSelectedBundleQuantity = (id) => ({
    type: QuantityActionTypes.BUNDLE_QUANTITY_ON_RESET,
    payload: id,
});
